import { Model } from '../../shared-features/models/model';
import { Expose } from 'class-transformer';
import { TruckOperationStatus } from "@shared-features/enums/truck-operation-status.enum";

export class RentedTruckStatus extends Model {
  @Expose() date: number;
  @Expose() status: TruckOperationStatus;
  @Expose() note: string;
}
